import { IonDate } from '../i-components/IonDate.tsx';

class BlastHistory {
    public autoID: string = '';
    public receiver_email_address: string = '';
    public email_subject: string = '';
    public email_content: string = '';
    public email_template: string = '';
    public datetime_created: Date | null = null;
    public blasted: boolean = false;

    constructor(
        autoID: string,
        receiver_email_address: string,
        email_subject: string,
        email_content: string,
        email_template: string,
        datetime_created: string,
        blasted: string
    ) {
        this.autoID = autoID
        this.receiver_email_address= receiver_email_address;
        this.email_subject = email_subject;
        this.email_content = email_content;
        this.email_template = email_template;
        this.datetime_created = IonDate(datetime_created);
        this.blasted = (blasted == '1' ? true : false);
    }
}
export default BlastHistory;